import format from "number-format.js";
import parseDecimalNumber from "parse-decimal-number";
import i18n from "../../i18n";

function getSeparator(locale: string, separatorType: string) {
  const numberWithGroupAndDecimalSeparator = 1000.1;
  return Intl.NumberFormat(locale)
    .formatToParts(numberWithGroupAndDecimalSeparator)
    .find(part => part.type === separatorType)
    .value;
}

function decimalSeparator(language: string): string {
  return getSeparator(language, 'decimal');
}

function thousandSeparator(language: string): string {
  return getSeparator(language, 'group');
}

export function parseNumeric(numberStr: string, language: string = i18n.language): number {
  if(typeof numberStr === 'number') {
    return numberStr;
  }
  return parseDecimalNumber(numberStr, {
    thousands: thousandSeparator(language),
    decimal: decimalSeparator(language)
  });
}

export function formatNumeric(numberValue: number | string, language: string = i18n.language): string {
  const mask = `0${decimalSeparator(language)}######`;
  const typedNumber = typeof numberValue === 'string' ? Number(numberValue) : numberValue;
  return format(mask, typedNumber);
}